import React from 'react';
import ForgotPasswordComponent from '../../Auth/forgotPassword';

export default function ForgotPassword() {
  return <ForgotPasswordComponent />;
}
